import { useQuery } from '@tanstack/react-query';

import { getAllTaxDocuments } from '@arrived/api_v2';
import { AccountId, TaxDocumentList } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { taxDocumentsKeyFn } from './taxDocuments.keys';

export function useGetTaxDocumentsQuery(accountId?: AccountId, options?: UseQueryOptions<TaxDocumentList>) {
  return useQuery(taxDocumentsKeyFn(accountId!), async () => getAllTaxDocuments(accountId!), {
    ...options,
    enabled: (options?.enabled ?? true) && accountId != null,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
